import { type OrderDetails } from '@koala/sdk';
import { type ConnectedProps, connect } from 'react-redux';
import HeartIcon from '@/components/uielements/heartIcon';
import meActions from '@/redux/me/actions';
import { type RootState } from '@/types/app';
import { fireGaEvent, gaActions, gaCats } from '@/utils/googleAnalytics';
import { isOrderFavorited } from '@/utils/orders';

interface Props extends ReduxProps {
  order: OrderDetails;
}

const _FavoriteIcon = ({
  order,
  addFavoriteOrder,
  removeFavoriteOrder,
  meFavoriteOrders,
}: Props) => {
  const toggleFavoriteOrder = (order: OrderDetails, favorite: boolean) => {
    if (favorite) {
      addFavoriteOrder(order.id);
      fireGaEvent(gaCats.account, gaActions.orderFavorited);
    } else {
      removeFavoriteOrder(order.id);
      fireGaEvent(gaCats.account, gaActions.orderUnfavorited);
    }
  };

  return (
    <HeartIcon
      favorites={true}
      active={isOrderFavorited(order.id, meFavoriteOrders)}
      onClick={(favorite: boolean) => toggleFavoriteOrder(order, favorite)}
      label={`Click to favorite order # ${order.id}`}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  meFavoriteOrders: state.app.me.favoriteOrders,
});

const mapDispatchToProps = {
  addFavoriteOrder: meActions.addFavoriteOrder,
  removeFavoriteOrder: meActions.removeFavoriteOrder,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export const FavoriteIcon = connector(_FavoriteIcon);
